import React from 'react';
import css from './ListingsTable.module.css';
import { ListingStatusSection } from '../../../util/enums';

/**
 * Component for selecting table tabs with category counts.
 * @param {Function} getTabState - Function to map tab state to active state
 * @param {Function} handleState - Handler to change the active state
 * @param {string} activeState - Current active state
 * @param {Object} categorizedListings - Object containing categorized listings (draft, published, closed)
 */
const TableSelection = ({
  getTabState,
  handleState,
  activeState,
  categorizedListings,
  isShopifyAccountPage,
  listingsAreLoading,
}) => {
  // Mapping of ListingStatusSection to categorizedListings keys
  const stateToKeyMap = {
    [ListingStatusSection.DRAFT]: 'draftListings',
    [ListingStatusSection.AVAILABLE]: 'publishedListings',
    [ListingStatusSection.SOLD]: 'soldListings', // Assuming SOLD is a category, adjust if needed
    [ListingStatusSection.CLOSED]: 'closedListings',
  };

  // Filter out SOLD if we're on Shopify account page
  const visibleStates = [
    ListingStatusSection.DRAFT,
    ListingStatusSection.AVAILABLE,
    ListingStatusSection.SOLD,
    ListingStatusSection.CLOSED,
  ].filter(state => !(isShopifyAccountPage && state === ListingStatusSection.SOLD));

  return (
    <div className={css.tabRow}>
      {visibleStates.map(state => {
        const key = stateToKeyMap[state];
        const count = listingsAreLoading ? 0 : categorizedListings[key]?.length || 0;
        const displayName = state.charAt(0).toUpperCase() + state.slice(1);
        return (
          <button
            type="button"
            key={state}
            className={`${css.tab} ${activeState === getTabState(state) ? css.activeTab : ''}`}
            onClick={() => handleState(state)}
          >
            {`${displayName} (${count})`}
          </button>
        );
      })}
    </div>
  );
};

export default TableSelection;
